import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import ticketMockupImg from 'assets/images/ticketMockup.png'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import React from 'react'
import QRReader from 'components/QrReader/QrReader'
import CameraAltIcon from '@mui/icons-material/CameraAlt'
import QrScanner from 'qr-scanner'
import { checkCode } from 'service/PreregisService'

const OrderVerification: React.FC = () => {
  const [orderNumber, setOrderNumber] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [errorText, setErrorText] = useState('')
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  const onSubmit = async () => {
    setIsLoading(true)
    const result = await checkCode(orderNumber)
    if (result.errorMessage !== '') {
      setErrorText(result.errorMessage)
    }
    // if (result?.data.statusCode === 110) {
    //   navigate(`/thankyou/${orderNumber}`)
    // }
    // if (result?.data.statusCode === 91) {
    //   navigate(`/thankyou/${orderNumber}`)
    // }
    if (result?.data.statusCode === 0) {
      navigate(`/information/${orderNumber}`)
    }
    setIsLoading(false)
  }

  return (
    <Stack direction={'column'} spacing={2}>
      <Box>
        <Typography variant="subtitle2" sx={{ fontSize: 22, mb: 0.5 }}>
          3-Day Live In-Person Event
        </Typography>
        <Typography variant="subtitle2" sx={{ fontSize: 16, fontWeight: 400 }}>
          Date: 12 - 14 Apr 2024
        </Typography>
        <Typography variant="subtitle2" sx={{ fontSize: 16, fontWeight: 400 }}>
          Time: 10AM
        </Typography>
        <Typography variant="subtitle2" sx={{ fontSize: 16, fontWeight: 400 }}>
          Venue: Singapore EXPO
        </Typography>
      </Box>
      {/* <Box>
        <Typography variant="subtitle2" align="center" sx={{ fontSize: 22, mb: 2 }}>
          Redeem Your Complimentary Ticket(s) Here
        </Typography>
      </Box> */}
      <Box sx={{}}>
        <Typography variant="subtitle2" sx={{ fontSize: 16 }}>
          Please enter your Redemption Code:
        </Typography>
        <div className="flex flex-col space-y-2">
          <TextField
            value={orderNumber}
            onChange={(e) => {
              setOrderNumber(e.target.value.replace(/^\s+|\s+$/gm, '').toUpperCase())
            }}
            label="Redemption Code"
            placeholder="Enter the 6-digit Redemption Code"
            variant="standard"
            error={!!errorText}
            helperText={errorText}
            size="small"
            // InputProps={{
            //   endAdornment: (
            //     <InputAdornment position="end">
            //       <IconButton
            //         aria-label="toggle cam"
            //         onClick={() => setOpen((prev) => !prev)}
            //         edge="end"
            //       >
            //         <CameraAltIcon style={{ color: '#000' }} />
            //       </IconButton>
            //     </InputAdornment>
            //   ),
            // }}
          />
          {/* <Button
            variant="outlined"
            component="label"
            disabled={!!orderNumber}
            sx={{ width: '200px', backgroundColor: '#FFF', color: '#000' }}
          >
            Upload QR code
            <input
              hidden
              accept="image/*"
              type="file"
              onChange={({ target }) => {
                const file = target.files ? target?.files[0] : undefined
                if (!file) {
                  return
                }
                QrScanner.scanImage(file, { returnDetailedScanResult: true })
                  .then((result) => {
                    if (result.data && result.data !== '') {
                      setOrderNumber(result.data)
                    }
                    console.log('result', result)
                  })
                  .catch((e) => console.log('e', e))
              }}
            />
          </Button> */}
        </div>
        <div className="flex justify-center pt-4">
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={orderNumber.replace(/-/g, '').length < 3 || isLoading}
            fullWidth
            sx={
              {
                // "&.Mui-disabled": {
                //   backgroundColor: "rgba(255, 255, 255, 0.2)",
                // },
              }
            }
          >
            {isLoading ? <CircularProgress size={24} sx={{ color: '#3bbbe6' }} /> : 'Submit'}
          </Button>
          <QRReader
            open={open}
            onClose={() => setOpen((prev) => !prev)}
            onScan={(value: string) => {
              setOrderNumber(value)
            }}
          />
        </div>
      </Box>
    </Stack>
  )
}

export default OrderVerification
